<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row>
      <b-col lg="4" md="6" sm="12">
        <b-card>
          <b-form @submit.prevent="uploadFile">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nieuw bestand">
                  <b-form-file v-model="newFeaturedImage" accept="image/*" required></b-form-file>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-button type="submit" variant="success" :disabled="!newFeaturedImage" class="btn btn-dark">Uploaden</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <template #overlay>
      <div class="text-center">
        <b-spinner label="Spinning"></b-spinner>
        <p>Bestanden worden verwerkt...</p>
        <!-- We add an SR only text for screen readers -->
        <span class="sr-only">Bestanden worden verwerkt...</span>
      </div>
    </template>
  </b-overlay>

</template>

<script>
  import {uploadData, addData} from "../../../api";

  export default {
    props: { options: null },

    data() {
      return {
        overlay: false,
        newFeaturedImage: null,
        url: null,
      };
    },

    methods: {
      uploadFile() {
        let formData = new FormData();

        formData.append('project_featured_images[]', this.newFeaturedImage);

        this.overlay = true

        uploadData(`projects/${this.$route.params.id}/media`, formData).then(({data}) => {
          this.overlay = false;
          this.newFeaturedImage = null;

          this.$emit('uploadedFiles', data);

        });
      },
    }
  }
</script>
